module.exports = __webpack_public_path__ + "img/public_hainan.7a29dd6e.png";